import React from 'react';
import { Typography } from 'antd';
import { DebugEntry } from '../../types/chat.types';
import './Chat.css';
import { FctEstado, type FctFamilia } from '../../fct/react';
import { fct } from '../../fct/tokens/tokens';

const { Text } = Typography;

interface DebugPanelProps {
  entries: DebugEntry[];
}

const DebugPanel: React.FC<DebugPanelProps> = ({ entries }) => {
  const formatTime = (date: Date) => {
    return new Date(date).toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  // Familia del semáforo por tipo de entrada (mapeo-estados.md §B: request neutro, response éxito, error riesgo).
  const getTagFamilia = (type: DebugEntry['type']): FctFamilia => {
    switch (type) {
      case 'request':
        return 'neutro';
      case 'response':
        return 'exito';
      case 'error':
        return 'riesgo';
    }
  };

  const getTagLabel = (type: DebugEntry['type']): string => {
    switch (type) {
      case 'request':
        return 'REQUEST';
      case 'response':
        return 'RESPONSE';
      case 'error':
        return 'ERROR';
    }
  };

  return (
    <div className="debug-panel">
      <div className="debug-panel-header">
        <Text strong style={{ color: fct.tinta.inversa }}>
          Debug / Monitor
        </Text>
      </div>
      <div className="debug-panel-content">
        {entries.length === 0 && (
          <div className="debug-panel-empty">
            <Text type="secondary">Sin actividad</Text>
          </div>
        )}
        {entries.map((entry, index) => (
          <div key={index} className={`debug-entry ${entry.type}`}>
            <div className="debug-entry-header">
              <FctEstado personalizado={{ etiqueta: getTagLabel(entry.type), familia: getTagFamilia(entry.type) }} />
              <Text type="secondary" className="fct-mono" style={{ fontSize: 11, color: fct.tinta['inversa-suave'] }}>
                {formatTime(entry.timestamp)}
              </Text>
            </div>
            <pre className="debug-entry-content">
              {JSON.stringify(entry.data, null, 2)}
            </pre>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DebugPanel;
